<template>
  <!-- <v-container> -->
    <v-slide-y-transition mode="out-in">
      <!-- <v-layout row> -->
        <!-- <v-flex xs12 sm6 offset-sm3> -->
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closedDialog()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Agendamento</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="save()">Salvar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-flex xs6 sm6 offset-sm3>
              <v-list three-line subheader>
                <v-subheader>Horário</v-subheader>
                <v-list-tile avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecione a hora*</v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-flex xs11 sm5>
                        <v-dialog
                          ref="dialog"
                          v-model="modal2"
                          :return-value.sync="proposedSurgeries.time"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="proposedSurgeries.time"
                              label="Hora para cirurgia"
                              prepend-icon="access_time"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="proposedSurgeries.time"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog.save(proposedSurgeries.time)">OK</v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-flex>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Selecione a Data</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-flex xs12 lg6>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="computedDateFormatted"
                            label="Data para cirurgia"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                      </v-menu>
                      <p>Date in ISO format: <strong>{{ date }}</strong></p>
                    </v-flex>
                  </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>

          <v-divider></v-divider>

            <v-alert
              :value="alertVisible"
              color="error"
            >
              {{alertTextRequired}}
            </v-alert>

            <v-snackbar
              :timeout="snackbarConfig.timeout"
              :color="snackbarConfig.color"
              :multi-line="snackbarConfig.mode === 'multi-line'"
              :vertical="snackbarConfig.mode === 'vertical'"
              v-model="snackbarConfig.snackbar"
            >
              {{ snackbarConfig.text }}
              <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
            </v-snackbar>

          <v-form @keyup.enter.native="save()" action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="save()">
          <!-- <v-form @keyup.enter.native="save()" action="#" lazy-validation ref="form" @submit.prevent="save()"> -->
            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
            <v-flex xs6 sm6 offset-sm3>
              <v-checkbox
                v-model="registered"
                label="Paciente Cadastrado?"
              ></v-checkbox>

              <v-text-field
                ref="name"
                v-if="!registered"
                :disabled="bodyData"
                label="Nome"
                v-model="proposedSurgeries.name"
                :counter="40"
                :required=!registered
                class="name"
              ></v-text-field>
              <v-radio-group v-model="proposedSurgeries.gender" row class="gender" v-if="!registered">
                <v-radio label="Masculino" value="M" color="blue"></v-radio>
                <v-radio label="Feminino" value="F" color="red"></v-radio>
              </v-radio-group>
              <v-text-field
                :required=!registered
                v-if="!registered"
                label="CPF"
                v-model="proposedSurgeries.cpf"
                :rules="[v => !!v || 'CPF obrigatório!!']"
                mask="###.###.###-##"
                class="cpf"
                :disabled="bodyData"
              ></v-text-field>
              <v-text-field
                v-if="!registered"
                label="Data Nasc."
                mask="date"
                v-model="proposedSurgeries.birthDay"
                :rules="[v => !!v || 'Data de Nasc. obrigatória!!']"
                :required=!registered
                class="birthDay"
                :disabled="bodyData"
              ></v-text-field>
              <v-select
                v-if="!registered"
                class="healthInsurance"
                ref="healthInsurance"
                item-text="name"
                item-value="id"
                label="Convênio"
                v-model="proposedSurgeries.healthInsurance"
                :items="healthInsurances"
                :rules="[v => !!v || 'Convênio obrigatório!!']"
                :required=!registered
              ></v-select>

              <v-flex xs12 sm12>
                  <v-form @keyup.enter.native="sendMessage()" action="#" ref="form" lazy-validation @submit.prevent="sendMessage()">
                    <v-text-field
                      v-if="registered"
                      v-model="message"
                      :append-icon="model ? 'arrow_back' : ''"
                      :append-outer-icon="message ? 'mdi-send' : 'search'"
                      :prepend-icon="icon"
                      box
                      clear-icon="mdi-close-circle"
                      clearable
                      label="Paciente/Dt Nascimento"
                      type="text"
                      @click:append="toggleMarker"
                      @click:append-outer="sendMessage"
                      @click:prepend="changeIcon"
                      @click:clear="clearMessage"
                    ></v-text-field>
                  </v-form>
              </v-flex>

              <v-progress-linear :indeterminate="true" v-show="loadingOk === true"></v-progress-linear>

              <v-list two-line v-if="!model" v-show="listVisible">
                <template v-for="(item, index) in items">
                  <v-subheader
                    v-if="item.header"
                    :key="item.header"
                  >
                    Selecione o nome
                    <!-- {{ item.header }} -->
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
                  ></v-divider>

                  <v-list-tile
                    v-else
                    :key="item.id"
                    avatar
                    @click="selectPatient(item)"
                  >
                    <v-list-tile-avatar color="indigo">
                      <span class="white--text headline">{{item.symbol}}</span>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.dateOfBirth"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>


              <v-select
                item-text="title"
                item-value="id"
                multiple
                chips
                hint="Pode selecionar várias cirurgias!"
                persistent-hint
                v-model="proposedSurgeries.surgery"
                :items="itemsSurgeries"
                :rules="[v => !!v || 'Cirurgia obrigatória!!']" required
                label="Cirurgia(s)*"
              ></v-select>

              <v-text-field
                v-model="proposedSurgeries.clinicalIndication"
                label="Indicação Clínica"
                :rules="[v => !!v || 'Indicação Clínica!!']" required
              ></v-text-field>

              <v-text-field
                v-model="proposedSurgeries.obs"
                label="Observacoes"
                required
              ></v-text-field>

              <h3 class="headline mb-0">Outras informacoes</h3>

              <v-select
                item-text="title"
                item-value="id"
                v-model="proposedSurgeries.anesthesia"
                :items="itemsAnesthesia"
                label="Indicação anestesica"
                required
              ></v-select>

              <v-checkbox
                v-model="proposedSurgeries.video"
                label="Video"
                required
              ></v-checkbox>

              <v-checkbox
                v-model="proposedSurgeries.debridador"
                label="Debridador"
                required
              ></v-checkbox>

              <v-text-field
                v-model="proposedSurgeries.instructorValue"
                label="Valor Instrumentação"
                required
              ></v-text-field>

              <v-text-field
                v-model="proposedSurgeries.medicalFee"
                label="Valor honorario Médico"
                required
              ></v-text-field>

              <v-text-field
                v-model="proposedSurgeries.assistantValue"
                label="Valor honorario Médico Auxiliar"
                required
              ></v-text-field>

              <v-checkbox
                v-model="proposedSurgeries.hemocomponentes"
                label="Hemocomponentes"
                required
              ></v-checkbox>
              <v-checkbox
                v-model="proposedSurgeries.OPME"
                label="OPME"
                required
              ></v-checkbox>
              <v-text-field
                v-model="proposedSurgeries.OPMETexto"
                label="OPME Texto"
                required
              ></v-text-field>
              <v-checkbox
                v-model="proposedSurgeries.pathologicalAnatomy"
                label="Anatomo Patologico"
                required
              ></v-checkbox>

              <v-text-field
                v-model="proposedSurgeries.CID"
                label="CID"
                required
              ></v-text-field>

              <v-text-field
                v-model="proposedSurgeries.fornecedor"
                label="Fornecedor"
                required
              ></v-text-field>

              <v-text-field
                v-model="proposedSurgeries.microscopio"
                label="Microscópio"
                required
              ></v-text-field>

              <!-- <v-btn
                :disabled="!valid"
                color="primary"
                @click="save()"
              >
                Salvar
              </v-btn> -->

              <v-alert
                :value="alertVisible"
                color="error"
              >
                {{alertTextRequired}}
              </v-alert>

              <v-btn
                :disabled="!valid"
                color="primary"
                @click="save()"
              >
                Salvar
              </v-btn>
              <!-- <v-btn @click="clear">Cancelar</v-btn> -->

              </v-flex>
              </v-layout>
            </v-container>
          </v-form>

        </v-card>
        <!-- </v-flex> -->
      <!-- </v-layout> -->
    </v-slide-y-transition>
  <!-- </v-container> -->
</template>

<script>
  import moment from 'moment'
  import { mapActions, mapGetters } from 'vuex'
  import store from '../../store'
  export default {
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
      model (val) {
        this.findOne()
      },
      navigation (val) {
      },
      search (val) {
        // Items have already been loaded
        // if (this.items.length > 0) return
        if ((val === null) || (val === undefined)) return
        if (isNaN(val) === false) this.findOne(this.model)

        this.isLoading = true

        // Lazily load input items
        window.axios.get(`${process.env.URL}/my-clinic-new/patient/find`, {
          params: {
            patient: val,
            customer: store.state.customer
          }
        }).then((response) => {
          // handle success
          this.items3 = response.data.results.results.map((item) => {
            return {
              id: item.tbCodigo,
              name: item.tbNome,
              symbol: 'BTC',
              website_slug: 'spitzer.io',
              dateOfBirth: item.tbDtNasc
            }
          })
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      }
    },
    mounted () {
      // this.proposedSurgeries.date = moment().format('DD-MM-YYYY')
      this.proposedSurgeries.date = new Date().toISOString().substr(0, 10)
      this.proposedSurgeries.time = moment().format('LT')
      this.itemsSurgeries = this.getSurgeries
      this.itemsAnesthesia = this.getAnesthesia
      this.loadHealthInsurance()
      this.focusInput()
    },
    computed: {
      ...mapGetters({ customer: 'customer', auth: 'auth' }),
      ...mapGetters('schedule', ['getSurgeries', 'getAnesthesia']),
      ...mapGetters('app', ['getTheme', 'getDevice']),
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      icon () {
        return this.icons[this.iconIndex]
      }
    },
    data (vm) {
      return {
        bodyData: false,
        snackbarConfig: {
          snackbar: false,
          color: 'error',
          mode: '',
          timeout: 6000,
          text: 'Erro de conexão com o servidor!'
        },
        alertTextRequired: '',
        alertVisible: false,
        registered: false,
        loadingOk: false,
        message: '',
        listVisible: false,
        iconIndex: 0,
        icons: [
          'mdi-emoticon',
          'mdi-emoticon-cool',
          'mdi-emoticon-dead',
          'mdi-emoticon-excited',
          'mdi-emoticon-happy',
          'mdi-emoticon-neutral',
          'mdi-emoticon-sad',
          'mdi-emoticon-tongue'
        ],
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        isLoading: false,
        model: null,
        search: null,
        active: null,
        snackbar: false,
        color: 'red',
        mode: '',
        timeout: 6000,
        text: 'Erro de servidor',
        menu: false,
        modal: false,
        modal2: false,
        healthInsurances: [],
        proposedSurgeries: {
          date: new Date().toISOString().substr(0, 10),
          record: null,
          clinicalIndication: '',
          obs: '',
          anesthesia: null,
          video: false,
          debridador: false,
          instructorValue: null,
          medicalFee: null,
          assistantValue: null,
          hemocomponentes: false,
          OPME: false,
          pathologicalAnatomy: false,
          CID: '',
          surgery: [],
          patient: null,
          fornecedor: '',
          lateralidade: '',
          OPMETexto: '',
          microscopio: '',
          gender: 'M'
        },
        valid: false,
        items: [],
        itemsSurgeries: [],
        itemsAnesthesia: [],
        items2: [],
        items3: []
      }
    },
    methods: {
      ...mapActions('schedule', ['setCreateProposedSurgeries']),
      ...mapActions('patient', ['setPatient']),
      validationsetTime () {
        this.alertVisible = true
        setTimeout(() => {
          if (this.alertVisible === true) {
            this.alertVisible = false
          }
        }, 3000)
      },
      focusInput () {
        this.$refs.name.focus()
      },
      loadHealthInsurance () {
        if (!this.customer) return false
        window.axios.get(process.env.URL + '/my-clinic-new/schedule-sync/health-insurance', {
          headers: {
            'x-access-token': this.auth.token
          },
          params: {
            customer: this.customer
          }
        }).then((healthInsurance) => {
          this.healthInsurances = healthInsurance.data.result
          this.healthInsuranceLoading = true
        }).catch((err) => {
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.color = 'warning'
          this.snackbarConfig.text = 'Erro ao carregar convênios, tente novamente!'
          console.error(err)
        })
      },
      selectPatient (item) {
        this.model = item.id
        this.findOne()
      },
      toggleMarker () {
        this.model = undefined
        this.show(0)
        // this.marker = !this.marker
      },
      sendMessage () {
        this.loadingOk = true
        window.axios.get(`${process.env.URL}/my-clinic-new/patient/find`, {
          params: {
            patient: this.message,
            customer: store.state.customer
          }
        }).then((response) => {
          // handle success
          this.items = response.data.results.results.map((item) => {
            return {
              id: item.tbCodigo,
              name: item.tbNome,
              symbol: item.tbNome.substr(0, 1),
              website_slug: 'spitzer.io',
              dateOfBirth: item.tbDtNasc
            }
          })
          this.listVisible = true
          this.loadingOk = false
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      clearMessage () {
        this.listVisible = false
        this.message = ''
        this.navigation = 'list'
        this.show(0)
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
      },
      closedDialog () {
        this.$bus.$emit('closeDialogScheduleProposed', false)
      },
      findOne () {
        if ((this.model === null) || (this.model === undefined)) return
        this.setPatient(this.model).then(() => {
        })
      },
      save () {
        if (this.$refs.form.validate()) {
          if (this.proposedSurgeries.surgery.length === 0) {
            console.error('Selecione uma cirurgia!')
            this.text = 'Selecione uma cirurgia!'
            this.alertTextRequired = 'Selecione uma cirurgia!'
            this.validationsetTime()
            this.snackbar = true
            return false
          } else if ((!this.model) && (this.registered)) {
            this.text = 'Selecione um paciente!'
            this.snackbar = true
            console.error('Selecione uma paciente!')
            this.alertTextRequired = 'Selecione um paciente!'
            this.validationsetTime()
            return false
          } else if (!this.proposedSurgeries.anesthesia) {
            this.text = 'Selecione uma indicacao anestesica!'
            this.snackbar = true
            console.error('Selecione indicacao anestesica!')
            this.alertTextRequired = 'Selecione indicacao anestesica!'
            this.validationsetTime()
            return false
          }
          if (this.$validator.validateAll()) {
            this.proposedSurgeries.birthDay = this.proposedSurgeries.birthDay.substring(2, 4) + '-' + this.proposedSurgeries.birthDay.substring(0, 2) + '-' + this.proposedSurgeries.birthDay.substring(4, 8)
            this.proposedSurgeries.date = this.date
            this.proposedSurgeries.record = this.model
            this.proposedSurgeries.doctor = this.auth.auth.myClinic.crm
            this.setCreateProposedSurgeries(this.proposedSurgeries)
          } else {
            this.snackbar = true
          }
          this.closedDialog()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/surgery-center/create.vue